// extracted by mini-css-extract-plugin
export var container = "_c7-1";
export var cornerButtonContainer = "_c7-6";
export var disabled = "_c7-2";
export var dragActive = "_c7-3";
export var fileContainer = "_c7-5";
export var hiddenInput = "_c7-4";
export var widthContainer = "_c7-0";